declare namespace $ {

	type $mol_view__sub_bog_builderui_alert_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_alert_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_builderui_alert extends $bog_builderui_card {
		title( ): string
		Alert_title( ): $mol_view
		text( ): string
		Alert_text( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=alert.view.tree.d.ts.map